import { Box, Paper, styled } from '@mui/material';

export const Animation = styled('div', { shouldForwardProp: (prop) => prop !== 'isOpen' })<{
	isOpen: boolean;
}>(({ isOpen }) => ({
	display: 'none',
	opacity: 0,
	transitionBehavior: 'allow-discrete',
	transitionProperty: 'opacity, display',
	transitionDuration: '600ms',

	...(isOpen && {
		display: 'block',
		opacity: 1,
	}),
}));

export const Modal = styled(Paper)({
	background: '#F3F9FF',
	borderRadius: '16px',
	padding: '24px',

	position: 'fixed',
	zIndex: 9999,
	width: 'min(530px, 95%)',
	left: '50%',
	top: '50%',
	transform: 'translate(-50%, -50%)',
	maxHeight: '90vh',
	overflow: 'auto',
});

export const Backdrop = styled('div')({
	background: '#0C364E66',
	backdropFilter: 'blur(25px)',
	position: 'fixed',
	inset: '0px',
	zIndex: '1',
	cursor: 'pointer',
});

export const Wrapper = styled('div')({
	margin: '8px auto',
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});

export const InnerWrap = styled(Paper)({
	background: '#FFFFFF80',
	borderRadius: '16px',
	padding: '8px',
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	gap: '8px',
	minWidth: '0px',

	'@container (max-width: 768px)': {
		background: 'none',
		boxShadow: 'none',
		gap: '8px',
		padding: '0px',
	},
});

export const FooterWrapper = styled(Box)({
	marginTop: '16px',
	display: 'flex',
	flexDirection: 'row',
	flex: 1,
	gap: '8px',
});
